import styled, { css } from 'styled-components';
import {
  colors,
  fade,
  s4,
  s8,
  radius,
  space,
  transitionTokens,
  easingTokens,
} from '@ardoq/design-tokens';
import { text2 } from '@ardoq/typography';
import { ICON_SELECTOR } from '@ardoq/icons';
import { focusableCSS } from '@ardoq/style-helpers';

export const IconContainer = styled.span`
  display: flex;
  align-items: center;
  color: ${colors.icon};
`;

export const Label = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Container = styled.div<{
  $isActive?: boolean;
  $isDisabled?: boolean;
}>`
  ${text2};
  color: ${colors.textDefault};
  display: inline-flex;
  border: 1px solid ${colors.borderAction};
  border-radius: ${radius.full};
  align-items: center;
  /* Subtract border width from padding */
  padding: calc(${space.xsmall} - 1px) ${space.small};
  gap: ${space.xsmall};
  cursor: pointer;
  vertical-align: bottom;
  ${fade};
  transition: all ${transitionTokens.small} ${easingTokens.cubicInOut};
  background-color: ${colors.surfaceDefault};

  /* Focus ring */
  outline: none;

  ${focusableCSS}
  &&::before {
    border-radius: ${radius.full};
  }

  ${props =>
    props.$isActive
      ? css`
          color: ${colors.textAction};
          background: ${colors.surfaceActive};
          border-color: ${colors.borderActionActive};

          ${ICON_SELECTOR} {
            color: ${colors.iconActionActive};
          }
        `
      : css`
          &:hover {
            border: 1px solid ${colors.borderActionHover};
            background-color: ${colors.surfaceHover};
          }
        `}
  ${props =>
    props.$isDisabled &&
    css`
      pointer-events: none;
      border: 1px solid ${colors.borderDisabled};
      color: ${colors.textDisabled};
    `}
`;

export const FilterChipContainer = styled(Container)`
  padding: 0 ${s8};
  gap: ${s4};
  cursor: default;
`;
